(function($) {
  $(document).ready(function() {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    var isOnIOS = navigator.userAgent.match(/iPad/i)|| navigator.userAgent.match(/iPhone/i);
    var eventName = isOnIOS ? "pagehide" : "beforeunload";
    window.addEventListener(eventName, (event) => {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      var centerX = windowWidth / 2;
      var centerY = windowHeight / 2;
      
      var elementsInCenter = document.elementsFromPoint(centerX + 100, centerY);
      let centeredProductId = $(elementsInCenter[0])
                              .closest('li.grid__item')
                              .find('.product-form [name="id"]')
                              .val();
      
      if ( $('#Huratips-Pagination a').length > 0 ) {
        var link = $('#Huratips-Pagination a').attr('href');
        var url = new URL(link, 'https://coconutlove.co/');
        var page = url.searchParams.get("page");
        var url = new URL(location.href);
        url.searchParams.set("IdToScroll", centeredProductId);
        url.searchParams.set("page", page - 1);
        var newURL = url;
        history.replaceState({}, '', newURL);
      }
    });
    
    var url = new URL(location.href);
    var IdToScroll = url.searchParams.get("IdToScroll");
    if ( IdToScroll ) {
      let toScroll = $(`[name="id"][value="${IdToScroll}"]`).closest('li.grid__item');
      if ( toScroll ) {
        var windowHeight = $(window).height();
        var elementHeight = toScroll.outerHeight();
        var scrollPosition = toScroll.offset().top - (windowHeight / 2) + (elementHeight / 2);
        $('html, body').animate({
            scrollTop: scrollPosition
        }, 500);
      }
      
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete("IdToScroll");
      const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
      history.replaceState(null, "", newUrl);
    }
  })
})(window.jQuery)